import React, { Component } from 'react';
import BuscadorModelosContables from './BuscadorModelosContables';
import ListaModelosSeleccionados from '../../Common/ListaModelosSeleccionados';


class ModalSeleccionModelos extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        // Data
        const {
            checkTodosModelos,
            inputBuscadorModelos,
            modelosContablesFiltrados,
            modelosContablesSeleccionados
        } = this.props;


        // Actions
        const{
            buscarModelosContables,
            cambiarCheckContabilizadorRecontabilizador,
            guardarQuitarModeloSeleccionado,
            mostrarOcultarModalContabilizadorRecontabilizador
        } = this.props
 
        let titulo = "Modelos Contables";
        
        return (
            <div className='modalContainer'>
                <div className="modal-filtros-ajuste-cargo">
                    <div className="modal-content">
                        <div className="modal-header-filtros-ajuste-cargo">
                            <div className="close-modal-filtros-ajuste-cargo" data-dismiss="modal" aria-hidden="true">
                                <label onClick={() =>  mostrarOcultarModalContabilizadorRecontabilizador("modalSeleccionModelos", false)} className="ti-close clickable"></label>
                            </div>
                            <h2 className="modal-title">{titulo}</h2>
                        </div>
                        <div className="modal-body-filtros-ajuste-cargo">
                            <div className="modal-body-container-cambiar-estados">
                                <BuscadorModelosContables 
                                    buscarModelosContables={buscarModelosContables}
                                    cambiarCheckContabilizadorRecontabilizador={cambiarCheckContabilizadorRecontabilizador}
                                    guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}

                                    checkTodosModelos={checkTodosModelos}
                                    inputBuscadorModelos={inputBuscadorModelos}
                                    modelosContablesFiltrados={modelosContablesFiltrados}
                                />
                                <div className="ContabilizadorRecontabilizador__separadorModelosSeleccionados"/>
                                <ListaModelosSeleccionados
                                    guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado}
                                    
                                    claseContenedor={"modalLogIntentosScroll ContabilizadorRecontabilizador__contenedorModelosSeleccionados ContabilizadorRecontabilizador__scrollModelosSeleccionadosEtiquetas"}
                                    modelosContablesSeleccionados={modelosContablesSeleccionados}
                                    mostrarEtiquetaTodos={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalSeleccionModelos;
